export type FAQ = { q: string; a: string; category: string };

export const FAQS: FAQ[] = [
  {
    category: "General",
    q: "What is RentOS?",
    a: "Rental management software for self-drive bikes, scooters and cars in India. One app covers bookings, fleet, customer KYC, payments, deposits, agreements and reports.",
  },
  {
    category: "General",
    q: "Who is it for?",
    a: "Owner-run rental businesses, typically around 5–50 vehicles. Each business has one owner account, not staff accounts or multiple branches.",
  },
  {
    category: "General",
    q: "Where can I use it?",
    a: "Use app.rentos.tech on a desktop or phone browser, or use the native Android and iOS Business app.",
  },
  {
    category: "Bookings",
    q: "How do I create a booking?",
    a: "Choose dates and times, check vehicle availability, set rent, deposit and any kilometre limit, choose or add a customer, then confirm. Pricing is frozen at creation.",
  },
  {
    category: "Bookings",
    q: "How does availability checking work?",
    a: "The vehicle picker checks existing bookings and the turnaround buffer. Extensions of active bookings also check the next booking for conflicts.",
  },
  {
    category: "Bookings",
    q: "What happens to a no-show?",
    a: "A booking automatically expires one hour after the scheduled pickup if the trip has not started.",
  },
  {
    category: "Trips",
    q: "What must be complete before pickup?",
    a: "Pickup is allowed from 30 minutes before the scheduled start until one hour after. Verified KYC, a complete pickup checklist and any required deposit collection are mandatory.",
  },
  {
    category: "Trips",
    q: "What does the checklist capture?",
    a: "Odometer and photo, fuel level, at least four vehicle photos, ID verification, existing damage and accessories issued. Return records odometer, fuel, at least four photos, new damage, accessories and extra charges.",
  },
  {
    category: "Trips",
    q: "How do late charges work?",
    a: "Your business grace period applies first. After grace, each whole started hour is charged at the hourly rate derived from the agreed booking rent. Active trips show a running estimate.",
  },
  {
    category: "Trips",
    q: "What is included in settlement?",
    a: "Rent plus late charges, extra kilometres over an agreed limit, and extra line items recorded at return. Fuel is recorded at pickup and return, not automatically billed.",
  },
  {
    category: "Trips",
    q: "Does recording a return generate the bill?",
    a: "No. The return checklist records condition and usage first. Generate the bill separately, collect the balance and settle the deposit. Fully paid and settled bookings complete and lock.",
  },
  {
    category: "KYC & Agreements",
    q: "Is identity verification automatic?",
    a: "No. The owner verifies driving licence, ID proof or passport at the counter and confirms consent. KYC changes have an audit trail. Pending KYC can be completed inline at pickup.",
  },
  {
    category: "KYC & Agreements",
    q: "How are agreements signed?",
    a: "Booking details pre-fill the agreement. The customer signs on screen with a finger or stylus. The signed agreement is stored with the booking and can be attached to configured emails.",
  },
  {
    category: "Payments",
    q: "Does RentOS process payments?",
    a: "No. Record cash, UPI, card or bank-transfer payments through the booking flow. The payments page is a read-only ledger, not a payment gateway.",
  },
  {
    category: "Payments",
    q: "How are deposits handled?",
    a: "Deposits stay in a separate ledger. At settlement, deduct charges or record a refund. Refunds create payment records. Only the kept portion counts as income.",
  },
  {
    category: "Payments",
    q: "Are invoices available?",
    a: "Yes. Print-ready, branded booking invoices include business and customer details, the trip, billing breakdown, payment history, deposit summary and a signature if signed. Automatic GST calculation is not included.",
  },
  {
    category: "Fleet",
    q: "What happens when insurance or PUC expires?",
    a: "The expiry is monitored automatically. The vehicle is blocked from new bookings and an alert is raised, with the reason shown.",
  },
  {
    category: "Fleet",
    q: "Can I keep maintenance history?",
    a: "Yes. Log damage, repairs, services and incidents with severity, status and cost. Damage captured on return feeds the vehicle history.",
  },
  {
    category: "Account",
    q: "Can I add staff or branches?",
    a: "No. RentOS is intentionally a single-owner Business app. It does not include staff accounts, roles, permissions or branches.",
  },
  {
    category: "Account",
    q: "What does a vehicle QR code do?",
    a: "It opens the vehicle’s page. Codes are downloadable and printable; they are not public self-booking, access control or scan analytics.",
  },
  {
    category: "Pricing",
    q: "Is there a Free tier?",
    a: "Yes. Paid plans scale with fleet size and enabled modules. Check current prices, inclusions and limits in the Business app.",
  },
  {
    category: "Pricing",
    q: "What happens on downgrade?",
    a: "Existing data is preserved. If active counts exceed the new plan’s limits, you cannot add beyond them until back under the limit. Expired subscriptions move to Free after a three-day past-due grace period.",
  },
  {
    category: "Pricing",
    q: "Which features are plan-controlled?",
    a: "Vehicles, bookings, customers, payments, maintenance, documents, QR and emails are module-controlled. Settings, notifications and reports are always available. Modules outside your plan are hidden.",
  },
  {
    category: "Security",
    q: "How is sensitive data protected?",
    a: "Customer phone, email, document numbers and SMTP passwords are encrypted at rest. Businesses have isolated data. Sign-in uses email and password with OTP verification, device-bound session rotation and rate limiting.",
  },
  {
    category: "Security",
    q: "Can I export my data?",
    a: "Yes. Export bookings, payments, customers and vehicles to CSV with date-range and column selection. Vehicle and customer imports include column mapping and a validation preview.",
  },
  {
    category: "Mobile",
    q: "What is included in the native app?",
    a: "The same Business app on Android and iOS, with native camera capture, file selection, sharing for invoices/exports/QR and push notifications. It is not a separate customer app.",
  },
  {
    category: "Notifications",
    q: "How are customer emails sent?",
    a: "Enable the emails module and configure your business’s own SMTP address in Settings. Booking confirmations, trip emails, invoices and pickup/return reminders use that address. An email failure does not prevent a booking.",
  },
  {
    category: "Notifications",
    q: "Which alerts does the owner receive?",
    a: "In-app overdue, no-show, document-expiry and subscription notifications, with preferences and unread badges. Native Android and iOS apps also receive push notifications.",
  },
  {
    category: "Reports",
    q: "Can I build custom reports?",
    a: "The app has a fixed analytics view with date-range selection: revenue, booking trends, utilisation, vehicle-type mix, top customers, payment methods and idle vehicles. It is not a custom report builder.",
  },
];
